import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { ReferralsReferrerActions } from '../referrers/referrers.store';
import { ReferralsRewardActions } from '../reward/reward.store';
import { ReferralsSettingsEntityHttpClient } from './settings-entity.http-client';
import { ReferralsSettingsEntityActions } from './settings-entity.store';

@Injectable({ providedIn: 'root' })
export class ReferralsSettingsEntityEffects {
  public effects = createEffectFactory(ReferralsSettingsEntityActions, this.actions$);

  public fetch$ = this.effects(ReferralsSettingsEntityActions.fetch, () =>
    this.http.loadReferralsSettings(),
  );

  public update$ = this.effects(ReferralsSettingsEntityActions.update, ({ payload }) =>
    this.http.updateReferralsSettings(payload),
  );

  public toggleReferralProgram$ = this.effects(
    ReferralsSettingsEntityActions.toggleReferralProgram,
    ({ payload }) =>
      this.http.toggleReferralProgram(payload).pipe(
        map(referralSettings =>
          ReferralsSettingsEntityActions.toggleReferralProgramSuccess({
            payload: referralSettings,
          }),
        ),
        catchError(error =>
          of(ReferralsSettingsEntityActions.toggleReferralProgramFailed({ payload: error })),
        ),
      ),
  );

  public refreshEntity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        ReferralsRewardActions.createOnePessimisticSuccess,
        ReferralsReferrerActions.deleteManySuccess,
        ReferralsRewardActions.deleteManySuccess,
      ),
      switchMap(() => [ReferralsSettingsEntityActions.fetch()]),
    ),
  );

  constructor(
    private actions$: Actions,
    private http: ReferralsSettingsEntityHttpClient,
  ) {}
}
